import BadRequestModal from './BadRequestModal.container';

export default BadRequestModal;
